module.exports = __webpack_public_path__ + "media/images/front/programs/icon-search-cf55dd39c8bb1e9353df0ffce60f7c7b.svg";